import { useTranslation } from 'react-i18next';

const Tooltipe = ({ method = null, text, icon, btnClass, id = null }) => {
  const { t } = useTranslation();

  return (
    <div className="tooltipe-wrap">
      <button className={`btn btn-icon ${btnClass}`} id={id} onClick={method}>
        <span className={`icon ${icon}`}></span>
      </button>
      <div className="tooltipe">{t(text)}</div>
    </div>
  );
};

export default Tooltipe;
